module.exports = __webpack_public_path__ + "static/media/distillery-interior.e91f026f.png";